/**
 * @Description This is FasatPageTitle container page
 * @FileName fasatPageTitle.js
 * @Author SAMAPTI TALUKDAR-talusam
 * @CreatedOn 27 January, 2021 14:15:00
 * @IssueID CDTFASATMOD- 298, 502
 */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import '../../../../index.scss';
import './fasatPageTitle.scss';
import { ActionButton, colors } from '@manulife/mux';
import { useTranslation } from 'react-i18next';
import { Delete, Edit, Export, ButtonPlusFilled } from '@manulife/mux-cds-icons';
import { staticCommonLabelKeys } from '../../moduleConstants';
import FasatRBAC from '../fasatRBAC/fasatRBAC';

function FasatPageTitle({ title, titleInItalics, ptAdd, ptEdit, ptDelete,
  handleActionBtn, addBtnText, editBtnText, deleteBtnText, editAclKey, rbacData,
  ptExport, exportBtnText }) {
  const [t] = useTranslation();
  const handleAction = useCallback(() => { handleActionBtn(addBtnText); }, [handleActionBtn]);
  const handleActionBtnText = useCallback(() => { handleActionBtn(editBtnText); }, [handleActionBtn]);
  const handleActionDeleteText = useCallback(() => { handleActionBtn(deleteBtnText); }, [handleActionBtn]);
  const handleActionExportBtnText = useCallback(() => { handleActionBtn(exportBtnText); }, [handleActionBtn]);
  return (
    <div className="titleSection">
      <h1
        id="fasatPgeTitleId"
        className={`${(ptAdd || ptEdit || ptDelete) ? '' : 'ptNoAction'} fasatPageTitle`}
        data-testid="FasatPageTitleComponent"
      >
        {title}
        {titleInItalics && (
        <span>
          {' '}
          {titleInItalics}
        </span>
        )}
      </h1>
      <div className="ptAction">
        { ptAdd && (
        <ActionButton
          aria-label={t(staticCommonLabelKeys.COMMON_BUTTON_ADD)}
          icon={<ButtonPlusFilled color={colors.m_green} aria-hidden="true" />}
          hoverIcon={<ButtonPlusFilled color={colors.dark_2_green} aria-hidden="true" />}
          onClick={handleAction}
          id="ptAddButton"
        >
          {t(staticCommonLabelKeys.COMMON_BUTTON_ADD)}
        </ActionButton>
        )}
        {ptEdit && (
          <FasatRBAC aclKey={editAclKey} userClaim={rbacData}>
            <ActionButton
              id="ptEditBtn"
              aria-label={t(staticCommonLabelKeys.COMMON_BUTTON_EDIT)}
              hoverIcon={<Edit color={colors.dark_2_green} aria-hidden="true" />}
              icon={<Edit color={colors.m_green} aria-hidden="true" />}
              onClick={handleActionBtnText}
            >
              {t(staticCommonLabelKeys.COMMON_BUTTON_EDIT)}
            </ActionButton>
          </FasatRBAC>
        )}
        {ptDelete && (
        <ActionButton
          id="ptDeleteBtn"
          hoverIcon={<Delete color={colors.dark_2_green} aria-hidden="true" />}
          icon={<Delete color={colors.m_green} aria-hidden="true" />}
          onClick={handleActionDeleteText}
          aria-label={t(staticCommonLabelKeys.COMMON_BUTTON_DELETE)}
        >
          {t(staticCommonLabelKeys.COMMON_BUTTON_DELETE)}
        </ActionButton>
        )}
        {ptExport && (
        <ActionButton
          id="ptExportBtn"
          hoverIcon={<Export color={colors.dark_2_green} aria-hidden="true" />}
          icon={<Export color={colors.m_green} aria-hidden="true" />}
          onClick={handleActionExportBtnText}
          aria-label={t(staticCommonLabelKeys.COMMON_BUTTON_EXPORT)}
        >
          {t(staticCommonLabelKeys.COMMON_BUTTON_EXPORT)}
        </ActionButton>
        )}
      </div>
    </div>
  );
}

FasatPageTitle.propTypes = {
  title: PropTypes.string,
  titleInItalics: PropTypes.string,
  handleActionBtn: PropTypes.func,
  ptAdd: PropTypes.bool,
  addBtnText: PropTypes.string,
  ptEdit: PropTypes.bool,
  editBtnText: PropTypes.string,
  ptDelete: PropTypes.bool,
  deleteBtnText: PropTypes.string,
  editAclKey: PropTypes.string,
  rbacData: PropTypes.shape({}),
  ptExport: PropTypes.bool,
  exportBtnText: PropTypes.string,
};

FasatPageTitle.defaultProps = {
  title: 'Page title',
  titleInItalics: '',
  handleActionBtn: undefined,
  ptAdd: false,
  addBtnText: 'Add',
  ptEdit: false,
  editBtnText: 'Edit',
  ptDelete: false,
  deleteBtnText: 'Delete',
  ptExport: false,
  exportBtnText: 'Export',
  editAclKey: '',
  rbacData: {},
};

export default FasatPageTitle;
